import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

function WhatsAppSupport() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  // Hide on admin panel and support tab
  const shouldHide = location.pathname === '/admin' || (location.pathname === '/subscriptions' && location.search.includes('tab=support'));

  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '923064158009';
  const discordInvite = process.env.REACT_APP_DISCORD_INVITE || 'https://discord.com/users/1436941841441230858';
  const telegramUsername = process.env.REACT_APP_TELEGRAM_USERNAME || 'openhosst';
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@openhosst.com';

  const handleContact = (channel) => {
    const message = encodeURIComponent('Hello! I have a general query about OpenHosst.');
    let url;
    switch(channel) {
      case 'whatsapp':
        url = `https://wa.me/${whatsappNumber}?text=${message}`;
        break;
      case 'discord':
        url = discordInvite;
        break;
      case 'telegram':
        url = `https://t.me/${telegramUsername}`;
        break;
      case 'email':
        url = `mailto:${supportEmail}?subject=General Query — OpenHosst&body=${message}`;
        break;
      default:
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
    setIsOpen(false);
  };

  const handleSupportTicket = () => {
    setIsOpen(false);
    window.location.href = '/subscriptions?tab=support';
  };

  if (shouldHide) return null;

  return (
    <div className="support-container">
      {isOpen && (
        <>
          <div className="support-overlay" onClick={() => setIsOpen(false)} />
          <div className="support-menu">
            <div className="support-menu-header">
              <h3>Contact Us</h3>
              <button className="support-close" onClick={() => setIsOpen(false)}>
                <i className="fa-solid fa-times"></i>
              </button>
            </div>

            <div className="support-divider">Subscription Support</div>
            <div className="support-divider-note">For issues with your active subscriptions, use the ticket system so we can track and resolve them properly.</div>

            <button className="support-option ticket" onClick={handleSupportTicket}>
              <div className="support-option-icon">
                <i className="fa-solid fa-ticket"></i>
              </div>
              <div className="support-option-content">
                <div className="support-option-title">Open a Support Ticket</div>
                <div className="support-option-subtitle">Tracked, official support for active subscriptions</div>
              </div>
              <i className="fa-solid fa-chevron-right support-option-arrow"></i>
            </button>

            <div className="support-divider">General Queries</div>
            <div className="support-divider-note">Sales, pre-purchase questions, or general chat.</div>

            <button className="support-option whatsapp" onClick={() => handleContact('whatsapp')}>
              <div className="support-option-icon">
                <i className="fa-brands fa-whatsapp"></i>
              </div>
              <div className="support-option-content">
                <div className="support-option-title">WhatsApp</div>
                <div className="support-option-subtitle">Chat with us</div>
              </div>
              <i className="fa-solid fa-chevron-right support-option-arrow"></i>
            </button>

            <button className="support-option telegram" onClick={() => handleContact('telegram')}>
              <div className="support-option-icon">
                <i className="fa-brands fa-telegram"></i>
              </div>
              <div className="support-option-content">
                <div className="support-option-title">Telegram</div>
                <div className="support-option-subtitle">Message us directly</div>
              </div>
              <i className="fa-solid fa-chevron-right support-option-arrow"></i>
            </button>

            <button className="support-option discord" onClick={() => handleContact('discord')}>
              <div className="support-option-icon">
                <i className="fa-brands fa-discord"></i>
              </div>
              <div className="support-option-content">
                <div className="support-option-title">Discord</div>
                <div className="support-option-subtitle">Send us a direct message</div>
              </div>
              <i className="fa-solid fa-chevron-right support-option-arrow"></i>
            </button>

            <button className="support-option email" onClick={() => handleContact('email')}>
              <div className="support-option-icon">
                <i className="fa-solid fa-envelope"></i>
              </div>
              <div className="support-option-content">
                <div className="support-option-title">Email</div>
                <div className="support-option-subtitle">{supportEmail}</div>
              </div>
              <i className="fa-solid fa-chevron-right support-option-arrow"></i>
            </button>
          </div>
        </>
      )}

      <button
        className="support-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Contact Us"
      >
        {!isOpen && <span className="support-tooltip">Contact Us</span>}
        <i className={`fa-solid ${isOpen ? 'fa-times' : 'fa-headset'}`}></i>
      </button>
    </div>
  );
}

export default WhatsAppSupport;
